import { useState, useEffect } from 'react';
import { Suspense } from 'App';
import { connect, useDispatch } from 'react-redux';

import { activeStepSet, nextStepSet, backStepSet, resetStepsDataSet } from 'store/steps';
import { resetGeneral, recaptchaStateSet, popupActiveSet, languageSet } from 'store/general';
import { resetAllUserData, resetUserDataSet, userDataSet } from 'store/userData';
import { journeyTypes } from 'assets/constants';

import { stepTypeEnum } from 'assets/constants';

import clsx from 'clsx';

import { BasePosition, BaseWrapper, Main } from './styles'
import { useTheme, useMediaQuery } from '@mui/material';

import { useActiveSteps, currentStepBlocker, useStepTypeInputStatus, useScrollToTop, useBackToFirstStep } from './hooks';

import { Header, NavigationHeader, NavigationFooter, Loader } from 'components';

import { useOnlineBookingApi, useOnlineBookingPopup } from 'shell';

import * as Screens from './'
import { useFirstRender } from 'hooks';
import { isBoolean, searchQuery } from 'utils';
import { useClientStateDataUpdate } from 'hooks/clientStateData';
import { useQueryClient } from 'react-query';
import { isDeepLink } from 'utils/src/journeyUtils';
import { useParams } from 'react-router';

const isPreview = searchQuery('p') === 't'

const OnlineWizardContent = ({
  language,
  isPreview,
  smallScreen, zoomedScreen,
  activeStep, activeStepSet,
  nextStepSet, backStepSet,
  stepStructure,
  successStepActive,
  popupState,
  stepCustomerDetailsDisabled,
  recaptchaStateSet,
  languageSet,
  userData,
  theme
}) => {
  const api = useOnlineBookingApi();
  const isFirstRender = useFirstRender();
  const MainPopup = useOnlineBookingPopup();
  const containerRef = useScrollToTop();
  const backToFirstStep = useBackToFirstStep();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  //override actions
  const [backButtonAction, setNavigationBack] = useState({ onNavigateBack: () => backStepSet(), navigateBackDisabled: true });
  const [nextButtonAction, setNavigateNext] = useState({ onNavigateNext: () => nextStepSet() });
  const [hasErrorPage, sethasErrorPage] = useState(false);
  const [blockNextButton, setBlockNextButton] = useState(false);

  const { journeyGuidFromUrl } = useParams();

  const clientStateDataUpdate = useClientStateDataUpdate();
  const { journeyGUID, identity } = userData || {};
  const handleNavigationStep = (index) => {
    setTimeout(() => {
      activeStepSet(index);
    }, 0);
  };

  const onUseStepQuerySuccess = (res) => {
    if (journeyGUID !== res.journeyGUID || identity !== journeyGuidFromUrl || isPreview) {
      sessionStorage.removeItem("end_user_token");
      queryClient.removeQueries({ queryKey: ['token-auth'] });
      !isPreview && dispatch(resetGeneral());
      dispatch(resetAllUserData());
      dispatch(resetStepsDataSet());
    }
    clientStateDataUpdate(res.clientStateData, res.journeyGUID, res.processGUID, journeyGuidFromUrl);
    if (res.errorCode > 0) {
      sethasErrorPage(true);
    }
    else if (isDeepLink() && !res.processGUID && !res.clientStateData?.customerGUID && !isPreview) {
      dispatch(resetUserDataSet())
      window.location.replace("./#/" + res.journeyGUID);
    }
  }
  const { isLoading: stepsIsLoading, data: journeyData, refetch, isRefetching: isStepsRefetching } = api.journey.useStepsQuery(isPreview, onUseStepQuerySuccess);


  const { identificationSettings } = journeyData || {};
  const { requireIdentification, requireVerification } = identificationSettings ?? { requireIdentification: true, requireVerification: true };

  const onValidateProcessError = (error) => sethasErrorPage(true);
  const onTokenSuccess = (res) => {
    sessionStorage.setItem("end_user_token", res.accessToken);
    nextStepSet();
  }
  const hasToken = () => {
    return !!sessionStorage.getItem("end_user_token");
  }

  const steps = useActiveSteps(journeyData, stepCustomerDetailsDisabled, hasErrorPage);
  const stepTypeInputStatus = useStepTypeInputStatus(steps, userData, activeStep, stepStructure);

  const errorPagePostion = steps?.findIndex(({ type }) => type === stepTypeEnum.errorPage);
  const customerIdentificationStepPosition = steps?.findIndex(({ type }) => type === stepTypeEnum.stepCustomerIdentification || type === stepTypeEnum.stepCustomerIdentificationReschedule || type === stepTypeEnum.stepCustomerIdentificationQuickReschedule);
  const onCustomerSucess = (res) => {
    dispatch(userDataSet({
      customerGUID: res.customerGUID,
      customerName: res.fullName || '',
      hasCustomer: true,
    }))
  }
  const { isLoading: tokenLoading } = api.auth.useGetToken(!hasToken() && !stepsIsLoading && !requireIdentification && !requireVerification && customerIdentificationStepPosition == activeStep, onTokenSuccess)

  const { error: servicesError } = api.errorPages.useErrorPagesQuery(
    journeyData?.processGUID,
    { skip: stepsIsLoading || tokenLoading || !journeyData || journeyData?.journeyTypeId !== journeyTypes.quickReschedule },
    onValidateProcessError
  );

  const { isLoading: customerDataIsLoading, data: customerData } = api.customer.useCustomerInfoQuery(hasToken() && !stepsIsLoading, onCustomerSucess)

  useEffect(() => {
    if (!journeyData?.clientStateData) return;
    if (!userData) return;
    //set the user data from the journey configuration
    dispatch(userDataSet({
      serviceType: { id: journeyData.clientStateData?.serviceTypeId || userData.clientStateData?.serviceTypeId },
      appointmentType: { id: journeyData.clientStateData?.appointmentTypeId || userData.clientStateData?.appointmentTypeId },
      location: { id: journeyData.clientStateData?.unitId || userData.clientStateData?.unitId },
      service: { id: journeyData.clientStateData?.serviceId || userData.clientStateData?.serviceId }
    }));
  }, [journeyData?.clientStateData])

  //when we have journeyData, extract and set language and recaptcha
  useEffect(() => {

    if (!journeyData) return;

    isBoolean(journeyData?.hasRecaptcha) && recaptchaStateSet(journeyData?.hasRecaptcha);

    //will trigger once on load if forceDefault is active
    if (journeyData.forceDefaultLanguage && 'forceDefault' in language) {
      languageSet({ lngCode: journeyData.defaultLanguage });
      return;
    }

    //if browser language exist in journey language
    if ((journeyData.languages || []).some(x => x.languageCode === language.lngCode))
      return;
    //set journey default language to client
    languageSet({ lngCode: journeyData.defaultLanguage })

  }, [journeyData]);

  //pull new journeyConfiguration on language change
  useEffect(() => { !isFirstRender && refetch() }, [language.lngCode])


  useEffect(() => { //on each step change focus on stepper navigation for ease of use
    //find all steppers and on step change find the active and focus on it
    if (!isFirstRender) {
      const parentElements = document.querySelectorAll('div.MuiStepper-root .MuiStep-root');
      parentElements?.forEach((parent) => parent.querySelector('span.Mui-active') && parent.focus());
    }

    const hasCustomerIdentification = customerIdentificationStepPosition != -1;

    if (hasCustomerIdentification && customerIdentificationStepPosition < activeStep && !hasToken()) {
      backToFirstStep();
    }
  }, [activeStep])

  //show not found page
  if (stepsIsLoading || customerDataIsLoading || tokenLoading || isStepsRefetching) return <Loader />;
  if (!steps) return <Suspense><Screens.Error /></Suspense>

  //indication that we in the last step
  const isLastStep = activeStep === steps?.filter(({ type }) => type !== stepTypeEnum.stepSuccess).length - 1;

  //indication that we are in date and time step and navigation to the step
  const dateAndTimeStepPosition = () => steps?.findIndex(({ type }) => type === stepTypeEnum.stepDateAndTime || type === stepTypeEnum.stepDateAndTimeReschedule || type === stepTypeEnum.stepDateAndTimeQuickReschedule);

  //function that desides to block step
  const currentStepBlocked = currentStepBlocker(
    steps,
    activeStep,
    stepTypeInputStatus,
    customerIdentificationStepPosition,
    hasToken(),
    popupState,
    blockNextButton
  );

  const renderNavigationHeader = () => {
    return (
      <NavigationHeader
        steps={steps}
        currentStepBlocked={currentStepBlocked}
        stepTypeInputStatus={stepTypeInputStatus}
        onNavigateClick={handleNavigationStep} />
    )
  }

  const renderHeader = () => {
    const { appTheme } = journeyData || {};

    //map languages to display in header
    const languages = journeyData.languages.map(({ languageCode }) => languageCode);

    return (
      <>
        <Header {...{ appTheme, smallScreen, zoomedScreen, languages, theme }} >
          {zoomedScreen && !successStepActive && renderNavigationHeader()}
        </Header>
        {!zoomedScreen && !successStepActive && renderNavigationHeader()}
      </>
    )
  }


  const renderStep = (step) => {
    if (!step) { return }
    // TODO refactor all code to resolve all undefined steps or journeyData
    const { id } = step;
    const { lngCode } = language;

    const props = {
      step,
      smallScreen, zoomedScreen, isPreview,
      lngCode,
      api,
      theme,
      journeyTypeId: journeyData?.journeyTypeId,
      setBlockNextButton,
      setNavigationBack,
      setNavigateNext
    };

    switch (true) {
      case step.type === stepTypeEnum.stepService: return <Screens.Service key={id} activeStep={activeStep}  {...props} />;
      case step.type === stepTypeEnum.stepDetails: return <Screens.Details key={id}  {...props} />;
      case step.type === stepTypeEnum.stepLocation: return <Screens.Location key={id} activeStep={activeStep} {...props} />;
      case [stepTypeEnum.stepQuestions, stepTypeEnum.stepQuestionReschedule, stepTypeEnum.stepQuestionQuickReschedule].includes(step.type): return <Screens.Questions key={id} {...props} />;
      case step.type === stepTypeEnum.stepServiceType: return <Screens.ServiceType key={id} activeStep={activeStep} {...props} props={props} />;
      case step.type === stepTypeEnum.stepDateAndTime || step.type === stepTypeEnum.stepDateAndTimeReschedule || step.type === stepTypeEnum.stepDateAndTimeQuickReschedule: return <Screens.Calendar key={id} activeStep={activeStep}  {...props} />;
      case step.type === stepTypeEnum.stepSetAppointment || step.type === stepTypeEnum.stepSetAppointmentReschedule || step.type === stepTypeEnum.stepSetAppointmentQuickReschedule: return <Screens.SetAppointment key={id}  {...{ ...props, dateAndTimeStepPosition: dateAndTimeStepPosition() }} journeyTypeId={journeyData?.journeyTypeId} />;
      case step.type === stepTypeEnum.stepAppointmentDetailsReschedule: return <Screens.AppointmentDetails sethasErrorPage={sethasErrorPage} key={id}  {...props} />;
      case [stepTypeEnum.stepCustomerIdentification,
      stepTypeEnum.stepCustomerIdentificationReschedule,
      stepTypeEnum.stepCustomerIdentificationQuickReschedule].includes(step.type):
        return <Screens.CustomerIdentification customerData={customerData} identificationSettings={identificationSettings} key={id} {...props} />;
      default: return <Screens.Error />;
    }
  }

  const renderErrorPage = (errorCode) => {
    const step = steps[errorPagePostion];
    const { appTheme, errorMessage } = journeyData || {};

    //map languages to display in header
    const languages = journeyData.languages.map(({ languageCode }) => languageCode);
    return (<>
      <Header {...{ appTheme, smallScreen, zoomedScreen, languages, theme }} >
        {zoomedScreen && !successStepActive && renderNavigationHeader()}
      </Header>
      <Suspense>
        <Screens.Error errorCode={errorCode} errorMessage={errorMessage} stepProps={step?.properties} api={api} />
      </Suspense>
    </>
    )
  }

  const renderMain = () => {
    return (
      <Main ref={containerRef} className={clsx({ successStepActive, previewSmallScreen: isPreview && smallScreen }, { 'BoxShadow': !successStepActive })}>
        <Suspense>
          {renderStep(steps[activeStep])}
        </Suspense>
        {popupState.open && <MainPopup />}
      </Main>
    )
  }

  const renderNavigationFooter = () => {
    const { onNavigateBack, navigateBackDisabled } = backButtonAction;
    const { onNavigateNext, buttonSetAppointment } = nextButtonAction;
    return (
      !successStepActive && (
        <NavigationFooter {...{ currentStepBlocked, onNavigateNext, onNavigateBack, isLastStep, buttonSetAppointment }}
          navigateBackDisabled={popupState.open || (activeStep === 0 && navigateBackDisabled)}
        />
      )
    )
  }



  return (
    <BasePosition>
      <BaseWrapper>
        {!hasErrorPage && renderHeader()}
        {!hasErrorPage && renderMain()}
        {!hasErrorPage && renderNavigationFooter()}
        {hasErrorPage && renderErrorPage(servicesError?.errorCode)}
      </BaseWrapper>
    </BasePosition>
  );
}

export const OnlineWizardContentContainer = connect(
  ({ current: {
    steps: { activeStep, stepStructure, successStepActive, stepCustomerDetailsDisabled },
    general: { language, popupState, recaptchaState },
    userData
  } }) => ({
    language,
    userData,
    activeStep,
    popupState,
    stepStructure,
    recaptchaState,
    successStepActive,
    stepCustomerDetailsDisabled,
  }),
  { activeStepSet, nextStepSet, backStepSet, recaptchaStateSet, popupActiveSet, languageSet }
)(OnlineWizardContent);

const OnlineWizard = ({ previewMobileView, resetStepsDataSet, resetUserDataSet }) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down('sm')) || !!previewMobileView;
  const zoomedScreen = useMediaQuery('@media (max-height: 480px)') && smallScreen;

  // useLayoutEffect(() => {
  //   if (isPreview) {
  //     sessionStorage.removeItem("end_user_token");
  //     resetStepsDataSet();
  //     resetUserDataSet();
  //   }
  // }, [isPreview])

  return <OnlineWizardContentContainer {...{ isPreview, smallScreen, zoomedScreen, theme }} />
};

export default connect(null, { resetStepsDataSet, resetUserDataSet })(OnlineWizard);
